/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import LandingPage from 'pages/LandingPage';
import { DiscussProjectPage } from 'pages/DiscussProjectPage';
import { CareersPage } from 'pages/CareersPage';
import { ServicesPage } from 'pages/ServicesPage';
import JobDetailPage from 'pages/JobDetailPage';

import { JobOpenings } from 'json/landingPageData';

import './assets/css/styles.css';

const STATIC_TITLES = {
  '/': 'Web7Labs — Building the Future Beyond Web3',
  '/services': 'Services — Web7Labs',
  '/careers': 'Join Us — Web7Labs',
  '/contact': 'Contact — Web7Labs',
};

function PageTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    let title = STATIC_TITLES[pathname];
    if (!title) {
      const match = pathname.match(/^\/careers\/([^/]+)$/);
      if (match) {
        const job = JobOpenings.find((j) => j.id === match[1]);
        title = job ? `${job.title} — Web7Labs` : 'Job — Web7Labs';
      }
    }
    document.title = title || 'Web7Labs | Building Digital Solutions';
  }, [pathname]);

  return null;
}

function App() {
  return (
    <>
      <PageTitle />
      <Routes>
        <Route exact path="/" element={<LandingPage />} />
        <Route exact path="/services" element={<ServicesPage />} />
        <Route exact path="/contact" element={<DiscussProjectPage />} />
        <Route exact path="/careers" element={<CareersPage />} />
        <Route exact path="/careers/:id" element={<JobDetailPage />} />
        <Route path="*" element={<LandingPage />} />
      </Routes>
    </>
  );
}

export default App;
